import { defineComponent as d, computed as l, openBlock as i, createElementBlock as s, createElementVNode as t, toDisplayString as h, createCommentVNode as f, normalizeStyle as n, createStaticVNode as p } from "vue";
const _ = ["viewBox"], v = /* @__PURE__ */ t("mask", { id: "f01d27ec-1547-41a3-8dc8-8784e1f13fb8" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#f01d27ec-1547-41a3-8dc8-8784e1f13fb8)" }, k = { key: 0 }, u = /* @__PURE__ */ p('<path fill="#d80027" d="M0 0h512v73L256 96 0 73Z"></path><path fill="#eee" d="M0 73h512v73l-256 23L0 146Z"></path><path fill="#333" d="M0 146h512v73l-256 23L0 219Z"></path><path fill="#ffda44" d="M0 219h512v74l-256 22L0 293Z"></path><path fill="#4a1f63" d="M0 293h512v73l-256 23L0 366Z"></path><path fill="#338af3" d="M0 366h512v73l-256 23L0 439Z"></path><path fill="#6da544" d="M0 439h512v73H0z"></path>', 7), g = { fill: "none" }, x = ["r"], L = /* @__PURE__ */ d({
  __name: "in-mn",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(c) {
    const e = c, o = l(() => 512 + 2 * e.strokeWidth), a = l(() => -e.strokeWidth), r = l(() => 256 + e.strokeWidth / 2);
    return (w, M) => (i(), s("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${a.value} ${a.value} ${o.value} ${o.value}`
    }, [
      v,
      t("g", m, [
        e.flagName ? (i(), s("title", k, h(e.flagName), 1)) : f("", !0),
        u
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: n({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, _));
  }
});
export {
  L as default
};
//# sourceMappingURL=in-mn-f8a210c7.js.map
